<div class="vtr-widget-warranty"
	[ngClass]="{'in-warranty': item.info.status == 0, 'expired': item.info.status ==1, 'not-found': item.info.status == 2}">
	<div class="container-fluid">
		<div class="row">
			<div class="col" *ngIf="item.info.status >= 0">
				<div class="title">{{'support.warranty.warrantyDashboardDetails' | translate}}</div>
				<div class="content"
					*ngIf="item.info.status !== 2">
					<div class="sub-description">
						<div class="left-col">
							<div class="pb-2">
								<span>{{'support.warranty.status' | translate}}</span><b>{{status.detail[item.info.status] | translate}}</b>
							</div>
						</div>
						<div class="right-col">
							<div class="pb-2">
								<span>{{'support.warranty.startDate' | translate}}</span>
								<b *ngIf="item.info.status !== 2">{{ item.info.startDate | formatLocaleDate}}</b>
								<b *ngIf="item.info.status === 2">{{'common.securityAdvisor.notFound' | translate}}</b>
							</div>
							<div class="pb-2">
								<span>{{'support.warranty.endDate' | translate}}</span>
								<b *ngIf="item.info.status !== 2">{{ item.info.endDate | formatLocaleDate }}</b>
								<b *ngIf="item.info.status === 2">{{'common.securityAdvisor.notFound' | translate}}</b>
							</div>
						</div>
					</div>
				</div>
				<div class="content"
					*ngIf="item.info.status === 2">
					<div class="sub-description pb-40">
						{{'support.warranty.subDescription2' | translate}}
						<span *ngIf="!isConnected && item.cache">{{'support.warranty.offlineTips1' | translate}}</span>
						<span *ngIf="!isConnected && !item.cache">{{'support.warranty.offlineTips2' | translate}}</span>
					</div>
				</div>
				<div class="button-box">
					<vtr-ui-button linkId="dashboard-view-warranty-options"
						buttonColor="gray"
						[isFullWidth]="true"
						[inRedBackground]="item.info.status==1"
						[label]="'support.warranty.viewWarrantyOptions' | translate"
						[href]="item.info.url"></vtr-ui-button>
				</div>
			</div>
		</div>
	</div>
</div>
